import PrivacyPolicy from "./PrivacyPolicy.presenter";
export default PrivacyPolicy;
